import { DocumentNode } from 'graphql/language';
import { customWriteQuery } from './customWriteQuery';
import {
  GetCurrentUserDocument,
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables,
} from '../casheQuery/__generated__/getUser';
import {
  GetNameProjectDocument,
  GetNameProjectQuery,
  GetNameProjectQueryVariables,
} from '../casheQuery/__generated__/getNameProject';

interface PropsWriteQuery<T, U> {
  dataWrite: T;
  _variables?: U;
}
interface Props extends PropsWriteQuery<object, object> {
  node: DocumentNode;
}

function writeQueryCache(props: Props): void {
  customWriteQuery({ ...props });
}

export function setUser(
  props: PropsWriteQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>
): void {
  writeQueryCache({ ...props, node: GetCurrentUserDocument });
}

export function setProjectName(
  props: PropsWriteQuery<GetNameProjectQuery, GetNameProjectQueryVariables>
): void {
  writeQueryCache({ ...props, node: GetNameProjectDocument });
}
